module.exports = __webpack_public_path__ + "static/media/CVKart-HD.11693968.png";